import { createTheme } from '@mui/material/styles';

export const AppTheme = createTheme({
  typography: {
    fontSize: 14,
    fontFamily: '"Inter", sans-serif'
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: (props) => ({
          color: '#4F4F4F',
          fontWeight: 300,
          fontSize: "16px",
          display: "block",
          position: "static",
          paddingBottom: props.theme.spacing(1),
          paddingLeft: 0,
          transform: 'unset',
        }),
      },
    },
    MuiInput: {
      styleOverrides: {
        input: (props) => ({
          height: "26px",
          fontSize: '18px',
          fontWeight: 300,
          paddingLeft: props.theme.spacing(2),
          paddingTop: props.theme.spacing(1),
          "&::placeholder": {
            textOverflow: "ellipsis !important",
            fontWeight: 300,
            color: "#171717",
          },
        }),
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          ".Mui-error.MuiFilledInput-root": {
            background: 'rgba(167, 65, 65, 0.1)',
            border: '2px solid #A74141',
          },

          ".Mui-focused.MuiInputLabel-root": {
            color: 'inherit',
            fontWeight: 600
          },
        }
      },
    },
    // Dropdown popups (Select's Menu, Autocomplete's listbox) default to MUI's 16px body text,
    // which reads noticeably larger than the 13px compact form fields used across admin drawers.
    // Fixing it here applies the match everywhere instead of per-component overrides.
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '13px',
          minHeight: '36px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          fontSize: '13px',
        },
        listbox: {
          fontSize: '13px',
        },
        noOptions: {
          fontSize: '13px',
        },
        loading: {
          fontSize: '13px',
        },
        groupLabel: {
          fontSize: '13px',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          background: 'rgba(48, 194, 222, 0.15)',
          border: "1px solid transparent",
          color: "#171717",
          ".Mui-error":{
            width: '100%',
          },
          "&.Mui-error.MuiOutlinedInput-notchedOutline": {
            background: 'rgba(167, 65, 65, 0.1)',
            border: '2px solid #A74141',
          },
          '&.Mui-focused': {
            backgroundColor: 'rgba(48, 194, 222, 0.15)',
            border: "2px solid rgba(117, 193, 218, 0.25) !important",
          },
          '&:hover': {
            backgroundColor: 'rgba(48, 194, 222, 0.15)',
            border: "1px solid rgba(117, 193, 218, 0.25)",
          }
        },

        input: (props) => ({
          height: "26px",
          fontSize: '18px',
          fontWeight: 300,
          paddingLeft: props.theme.spacing(2),
          paddingTop: props.theme.spacing(1),
          "&::placeholder": {
            textOverflow: "ellipsis !important",
            fontWeight: 300,
            color: "#171717",
          },
        }),
      },
      variants: [
        {
          props: { readOnly: true },
          style: props => ({
            backgroundColor: '#F3F3F3',
            border: '1px solid transparent',
            '&.Mui-focused': {
              backgroundColor: '#F3F3F3',
              border: '1px solid transparent !important',
            },
            '&:hover': {
              backgroundColor: '#F3F3F3',
              border: '1px solid transparent',
            }
          }),
        },
        {
          props: { multiline: true },
          style: props => ({
            backgroundColor: '#FFFF',
            border: '1px solid #30C2DE',
            '&.MuiFilledInput-root': {
              height: '100%',
            },
            '&.MuiInputBase-multiline textarea': {
              height: '100% !important',
            },
            '&.Mui-focused': {
              backgroundColor: '#FFFF',
            },
          }),
        },
        {
          props: { multiline: true, readOnly: true },
          style: props => ({
            backgroundColor: '#F3F3F3',
            border: '1px solid transparent',
            '&.MuiFilledInput-root': {
              height: '100%',
              backgroundColor: '#F3F3F3',
              border: '1px solid transparent !important',
            },
            '&.MuiInputBase-multiline textarea': {
              height: '100% !important',
              backgroundColor: '#F3F3F3',
              border: '1px solid transparent !important',
            },
            '&.Mui-focused': {
              backgroundColor: '#F3F3F3',
              border: '1px solid transparent !important',
            },
          }),
        }
      ],
      defaultProps: {
        disableUnderline: true,
      },
    },
  }
});